import {
  Badge, HStack, Image, Text,
} from '@chakra-ui/react';
import _ from 'lodash';
import { If, Then } from 'react-if';

import { IFileAnalysisResponse } from 'api/types/trueFileServerTypes';
import CriticalIcon from 'assets/icons/critical-icon.svg';
import CriticalWarningIcon from 'assets/icons/critical-warning.svg';
import PassedIcon from 'assets/icons/passed-icon.svg';
import RunningAnalysisIcon from 'assets/icons/running-analysis-icon.svg';

export function FileValidationBadges({ data }: { data: IFileAnalysisResponse | undefined; }): JSX.Element {
  const errors = data?.validationResult?.errors?.filter((e) => e.severity === 'Error') || [];
  const warnings = data?.validationResult?.errors?.filter((e) => e.severity === 'Warning') || [];

  return (
    <HStack spacing={4}>
      <If condition={data?.status !== 'failed' && data?.status !== 'success'}>
        <Then>
          <Badge
            colorScheme='blue'
            textTransform='none'
            display='flex'
            px={2}
            py={2}
            alignItems='center'
            borderRadius={8}
          >
            <Image src={RunningAnalysisIcon} style={{ width: 16, height: 16, marginRight: 4 }} />
            <Text>{data?.status ? _.startCase(data?.status) : 'Loading…'}</Text>
          </Badge>
        </Then>
      </If>

      <If condition={data?.status === 'failed'}>
        <Then>
          <Badge
            colorScheme='red'
            textTransform='none'
            display='flex'
            px={2}
            py={2}
            alignItems='center'
            borderRadius={8}
          >
            <Image src={CriticalIcon} style={{ width: 16, height: 16, marginRight: 4 }} />
            <Text>Critical Issues Detected</Text>
          </Badge>
        </Then>
      </If>

      <If condition={data?.status === 'success' && errors.length > 0}>
        <Then>
          <Badge
            colorScheme='red'
            textTransform='none'
            display='flex'
            px={2}
            py={2}
            alignItems='center'
            borderRadius={8}
          >
            <Image src={CriticalIcon} style={{ width: 16, height: 16, marginRight: 4 }} />
            <Text>{errors.length} Critical Issues</Text>
          </Badge>
        </Then>
      </If>
      <If condition={data?.status === 'success' && warnings.length > 0}>
        <Then>
          <Badge
            colorScheme='yellow'
            textTransform='none'
            display='flex'
            px={2}
            py={2}
            alignItems='center'
            borderRadius={8}
          >
            <Image src={CriticalWarningIcon} style={{ width: 16, height: 16, marginRight: 4 }} />
            <Text>{warnings.length} Warning</Text>
          </Badge>
        </Then>
      </If>
      <If condition={(data?.passedCount ?? 0) > 0 && data?.status === 'success'}>
        <Then>
          <Badge
            colorScheme='green'
            textTransform='none'
            display='flex'
            px={2}
            py={2}
            alignItems='center'
            borderRadius={8}
          >
            <Image src={PassedIcon} style={{ width: 16, height: 16, marginRight: 4 }} />

            <Text>{data?.passedCount} Passed</Text>
          </Badge>
        </Then>
      </If>
    </HStack>
  );
}
